export default __webpack_public_path__ + "static/media/mall-hall-grey.5a022631.svg";